import Vue from "vue";
export default Vue.extend({
  name: "mixin-button-text-on",
  props: {
    pTextOn: { type: Boolean, default: true },
  },
  data() {
    return {
      textOn: true,
    };
  },
  created() {
    this.watchPTextOn();
    this.textOn = this.pTextOn;
  },
  methods: {
    watchPTextOn() {
      this.$watch(
        () => {
          return this.pTextOn;
        },
        (newValue: boolean) => {
          console.log(`watch pTextOn in button-text-on: ${newValue}`);
          this.textOn = newValue;
        }
      );
    },
  },
});
